





























































































































































































import BtnDefault from '@/components/UI/BtnDefault.vue';
import {Component, Vue, Watch} from 'vue-property-decorator';
import DialogFooter from '@/components/UI/DialogFooter.vue';
import {namespace} from 'vuex-class';
import TableComponent from "@/components/UI/TableComponent.vue";
import Modal from '@/components/UI/Modal.vue';

const dialog = namespace('dialog')
const forms = namespace('forms')
const products = namespace('products')

@Component({
  components: {
    BtnDefault,
    DialogFooter,
    TableComponent,
    Modal,
  },
  name: "AddProductForm"
})
export default class AddProductForm extends Vue {

  @dialog.Getter('fullDialogShow') protected fullDialogShow: any
  @dialog.Mutation('SetFullDialogShow') protected SetFullDialogShow: any
  @forms.Getter('options') protected options:any
  @products.Action('saveNewProduct') protected saveNewProduct:any
  @products.Getter('thematics') protected thematics: any

  tab:string = 'tab-1'
  title:string = ''
  vendorCode:string = ''
  description:string = ''
  character:any = {
    title: "",
    value: ""
  }
  characters:any = []
  currentCharacter:any = {}
  isDeleteCharacter:boolean = false
  link:any = {
    title: "",
    value: ""
  }
  promo:any = []
  currentPromo:any = {}
  isDeletePromo:boolean = false
  thematic:string = ''

  @Watch('fullDialogShow')
  resetOptions() {
    if(!this.fullDialogShow) {
      this.title = ''
      this.vendorCode = ''
      this.description = ''
      this.character = {
        title: '',
        value: ''
      }
      this.characters = []
      this.link = {
        title: '',
        value: '',
      }
      this.promo = []
      this.tab = 'tab-1'
      this.thematic = ''
    }
  }

  get headersCharacter() {
    return [
      { text: this.$t('products.add.properties.caption'), value: 'title', sortable: false },
      { text: this.$t('products.add.properties.value'), value: 'value', sortable: true },
      { text: '', value: 'delete', sortable: false, width: '56', type: 'icon', action: 'deleteCharacterModal' },
    ]
  }
  get headersPromo() {
    return [
      { text: this.$t('products.add.links.description'), value: 'title', sortable: false },
      { text: this.$t('products.add.links.value'), value: 'value', sortable: true },
      { text: '', value: 'delete', sortable: false, width: '56', type: 'icon', action: 'deletePromoModal' },
    ]
  }

  get isValid() {
    return this.title.length != 0
  }

  get isValidCharacter() {
    return this.character.title.length != 0 && this.character.value.length != 0
  }

  get isValidPromo() {
    return this.link.title.length != 0 && this.link.value.length != 0
  }

  clickTable(item:any, action:any) {
    this[action as keyof AddProductForm](item)
  }

  addCharacter() {
    this.characters.push(this.character)
    this.character = {
      title: '',
      value: ''
    }
  }

  deleteCharacterModal(item:any) {
    this.currentCharacter = item
    this.isDeleteCharacter = true
  }

  deleteCharacter() {
    this.characters = this.characters.filter((character:any) => character != this.currentCharacter)
    this.isDeleteCharacter = false
  }

  addPromo() {
    this.promo.push(this.link)
    this.link = {
      title: '',
      value: ''
    }
  }

  deletePromoModal(item:any) {
    this.currentPromo = item
    this.isDeletePromo = true
  }

  deletePromo() {
    this.promo = this.promo.filter((link:any) => link != this.currentPromo)
    this.isDeletePromo = false
  }

  save() {
    let params = {
      title: this.title,
      vendorCode: this.vendorCode,
      description: this.description,
      characters: this.characters,
      promo: this.promo,
      thematic: this.thematic
    }
    this.saveNewProduct(params)
    this.SetFullDialogShow(false)
  }


}
